import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProjectPage from './pages/ProjectPage';
import TasksListPage from './pages/TasksListPage';
import ServersPage from './pages/ServersPage';
import ServerDetailPage from './pages/ServerDetailPage';
import CybersecurityPage from './pages/CybersecurityPage';
import SecurityProjectPage from './pages/SecurityProjectPage';
import SecurityIpDetailPage from './pages/SecurityIpDetailPage';
import SecurityEventDetailPage from './pages/SecurityEventDetailPage';
import SecurityMonitoredDetailPage from './pages/SecurityMonitoredDetailPage';
import SecurityRegistryUpdateDetailPage from './pages/SecurityRegistryUpdateDetailPage';

function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #0f0f1a 100%)',
      color: 'rgba(255,255,255,0.6)', fontSize: 14, letterSpacing: '0.04em',
    }}>
      Loading…
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useApp();
  if (loading) return <LoadingScreen />;
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isLoggedIn, loading } = useApp();
  if (loading) return <LoadingScreen />;
  return !isLoggedIn ? children : <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/servers" element={<ProtectedRoute><ServersPage /></ProtectedRoute>} />
          <Route path="/servers/:serverId" element={<ProtectedRoute><ServerDetailPage /></ProtectedRoute>} />
          <Route path="/cybersecurity" element={<ProtectedRoute><CybersecurityPage /></ProtectedRoute>} />
          <Route path="/cybersecurity/project/:source" element={<ProtectedRoute><SecurityProjectPage /></ProtectedRoute>} />
          <Route path="/cybersecurity/ip/:source/:ip" element={<ProtectedRoute><SecurityIpDetailPage /></ProtectedRoute>} />
          <Route path="/cybersecurity/event/:source/:id" element={<ProtectedRoute><SecurityEventDetailPage /></ProtectedRoute>} />
          <Route path="/cybersecurity/monitored/:source/:id" element={<ProtectedRoute><SecurityMonitoredDetailPage /></ProtectedRoute>} />
          <Route path="/cybersecurity/registry-update/:id" element={<ProtectedRoute><SecurityRegistryUpdateDetailPage /></ProtectedRoute>} />
          <Route path="/tasks/:filter" element={<ProtectedRoute><TasksListPage /></ProtectedRoute>} />
          <Route path="/project/:projectId" element={<ProtectedRoute><ProjectPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
